import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { sizes, types, } from './constants';
const textStyles = {
    [types.primary]: css `
    text-transform: uppercase;
  `,
    [types.secondary]: css `
    text-transform: none;
  `,
};
const activeStyles = css `
  background: ${theme.colors.gray300};
  border-left: ${styleUtils.rem(3)} solid '#91ac4c';
  color: ${theme.colors.gray700};
  ${theme.typeStyles.bodyBoldStyles}
`;
const menuItemAnchorStyles = css `
  text-decoration: none;
  color: ${theme.colors.gray600};
  display: block;
  border-left: ${styleUtils.rem(3)} solid transparent;
  letter-spacing: ${styleUtils.rem(0.5)};
  text-transform: uppercase;
  font-weight: 300;
  ${styleUtils.transition([
    'background',
    'color',
])}

  &:hover {
    background: ${theme.colors.gray300};
    color: ${theme.colors.gray700};
  }
`;
const menuItemStyles = css `
  display: block;
  margin: 0;
`;
const menuWrapperStyles = css `
  background: ${theme.colors.gray100};
  display: block;
  margin: ${styleUtils.rem(16)} 0 0;
  padding: ${styleUtils.rem(12)} 0;
  min-width: ${styleUtils.rem(200)};
`;
const defaultProps = {
    size: sizes.medium,
    type: types.primary,
};
const Menu = ({ items, size = defaultProps.size, type = defaultProps.type, }) => {
    const sizeStyles = useMemo(() => ({
        [sizes.medium]: css `
      ${theme.typeStyles.bodySmallStyles}
      padding: ${type === types.primary ? `${styleUtils.rem(16)} ${theme.spacing.x6}` : `${styleUtils.rem(12)} ${theme.spacing.x6}`};
    `,
        [sizes.small]: css `
      ${theme.typeStyles.bodyExtraSmallStyles}
      padding: ${type === types.primary ? `${theme.spacing.x3} ${theme.spacing.x6}` : `${theme.spacing.x2} ${theme.spacing.x6}`};
    `,
    }), [
        type,
    ]);
    const menuItemEnhancedStyles = useMemo(() => ([
        menuItemAnchorStyles,
        textStyles[type],
        sizeStyles[size],
    ]), [
        size,
        sizeStyles,
        type,
    ]);
    return (_jsx("nav", { children: _jsx("ul", Object.assign({ css: menuWrapperStyles }, { children: items && items.map((item) => (_jsx("li", Object.assign({ css: menuItemStyles }, { children: _jsx("a", Object.assign({ css: [
                        menuItemEnhancedStyles,
                        css `
                    border-bottom: ${item.divider ? `${styleUtils.rem(1)} solid ${theme.colors.gray300}` : `${styleUtils.rem(1)} solid transparent`};
                    ${item.active ? activeStyles : ''}
                  `,
                    ], href: item.url }, { children: item.label })) }), item.label))) })) }));
};
const MemoizedMenu = memo(Menu);
export { MemoizedMenu as Menu };
// MC-1068 Temporary hack for Storybook.
export default Menu;
